
import Modal from '../../modal/src/modal'
import Panel from '../../panel/src/panel'

import { foreignProps } from 'vessel/utils'

const modal = foreignProps(Modal, {
  except: ['sizes', 'sizeProp'],
  defaults: {
    animate: () => ({
      duration: 'faster',
      name: 'fade',
      enter: 'up',
      leave: 'down'
    })
  }
})

const panel = foreignProps(Panel, {
  except: ['srollable'],
  defaults: {
    background: 'white',
    border: true,
    shadow: true
  }
})

const sizes = {
  mini:   '30rem',
  small:  '40rem',
  medium: '50rem',
  large:  '60rem'
}

export default {
  name: 'VsDialog',
  model: {
    prop: 'visible',
    event: 'update:visible'
  },
  props: {
    ...modal.props,
    ...panel.props
  },
  watch: {
    visible: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          newValue ? this.open() : this.close()
        }
      }
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  computed: {
    modalAttrs() {
      const attrs = { sizes }
      const props = modal.fetch(this.$props)

      return { ...props, ...attrs }
    },
    panelAttrs() {
      return panel.fetch(this.$props)
    }
  },
  methods: {
    open() {
      this.isVisible = true

      this.$emit('open')
      this.$emit('update:visible', true)
    },
    close() {
      this.isVisible = false

      this.$emit('close')
      this.$emit('update:visible', false)
    },
    toggle() {
      this.isVisible ? this.close() : this.open()
    },
    onEnter() {
      if (this.name) {
        this.$dialog.active = this.name
      }
    },
    onLeave() {
      if (this.name && this.$dialog.active == this.name) {
        this.$dialog.active = null
      }
    }
  },
  mounted() {
    if (this.name) {
      this.$dialog.register(this.name, this)
    }
  },
  destroyed() {
    if (this.name) {
      this.$dialog.unregister(this.name)
    }
  }
}
